module.exports = __webpack_public_path__ + "img/chat_bg2.f768d942.png";